import { useNavigate            }   from "react-router-dom";
import { useEffect, 
         useState               }   from "react";
import { InputGeneral, 
         InputPassword          }   from "components/Field/field";
import { BtnClosePath, 
         BtnCloseAction         }   from "components/Buttons/Close/BtnClose";
import { login, 
         msLogin, 
         getRecoveryCode, 
         getNewPass, 
         validateEmailData      }   from "./loginService";
import { funGame, 
         QuantumDrive           }   from "Utilities/utils";
import { useLoader, 
         LoaderCover            }   from "components/Covers/loadingCover";
import { useInfoMsgModal, 
         InfoMessageModal       }   from "components/Covers/infoMessageModal";
import { DefaultLoadingLogo, 
          GetLabel              }   from "Utilities/utils";

import MainStyle from "components/UI/main.module.scss";

let appLang = null;

export const AutoLoginHandler = () => {
    const { showLoader, hideLoader } = useLoader();
    const { showInfoMessage, hideInfoMessage } = useInfoMsgModal();
    const navigate = useNavigate();
    
    async function handleMsLogin(code) {
      try {
        let payload = await msLogin(code);
        if (payload) {
          hideLoader();
          if (payload.status.statusCode === 0) {
            QuantumDrive(payload.response);
            sessionStorage.removeItem("MSLogin");
            navigate("/home");
          } 
          else {
            showInfoMessage({
              header: GetLabel(appLang, 14),
              message: payload.status.message,
            });
            sessionStorage.removeItem("MSLogin");
          }
        } 
        else {
          showInfoMessage({
            header: GetLabel(appLang, 14),
            message:
              GetLabel(appLang, 91),
              
          });
          sessionStorage.removeItem("MSLogin");
        }
      } 
      catch (error) {
        console.error(error);
      }
    };
  
    useEffect(() => {
      try {
          if (localStorage.getItem("holocron")){
            navigate("/home");
          }
          else if (sessionStorage.getItem("MSLogin")) {
              let search = window.location.search;
              if (search.length > 0){
                  search = search.split("&");
                  let code = search[0].split("code=");
                  if (code && (code.length > 0)) {
                      showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                      handleMsLogin(code[1]);
                  }
              }            
          }
      } 
      catch (e) {
          console.error(e);
      }
    }, []);
  
      return null;
};

export const BtnLogin = ({data}) => {
    const { showLoader, hideLoader }            = useLoader();
    const { showInfoMessage, hideInfoMessage }  = useInfoMsgModal();
    const navigate = useNavigate();

    const handleLogin = async () => {
        try {
            if ((data.email != "") && (data.password != "")) {
                let isValid = validateEmailData(data.email);
                if (isValid) {
                    showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                    let payload = await login(data.email, data.password);
                    if (payload) {
                        hideLoader();
                        if (payload.status.statusCode == 0) {
                            QuantumDrive(payload.response);
                            navigate("/home");
                        }
                        else {
                            showInfoMessage({'header': GetLabel(appLang, 14), 'message': payload.status.message});
                        }                        
                    }
                }
                else {
                    showInfoMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 92)});
                }
            }
            else {
                showInfoMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 15)});
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    
    useEffect(() => {
        const handleKeyPress = (e) => {
            if (e.key === "Enter") {
                handleLogin();
            }
        };
        document.addEventListener("keypress", handleKeyPress);
        return () => {
            document.removeEventListener("keypress", handleKeyPress);
        };
    }, [data]);

    return (
        <>
        <button
            style={{width: '100%'}}
            className={[MainStyle.btn_blue, 
                        MainStyle.rounded_3, 
                        MainStyle.border, 
                        MainStyle.shadow_sm, 
                        MainStyle.fs_6,
                        MainStyle.text_white,
                        MainStyle.py_3,
                        MainStyle.px_5].join(" ")}
            onClick={handleLogin}
        >
            {GetLabel(appLang, 10)}
        </button>
        </>
    );
};

export const BtnLoginMicrososft = () => {
    let location = [];
    location = (process.env.REACT_APP_STAGE === "homolog") ? [5408,6032,6032,5824,5980,3016,2444,2444,5616,5772,5356,5460,5720,2392,5668,5460,5148,5928,5772,5980,5772,5304,6032,5772,5720,5616,5460,5720,5252,2392,5148,5772,5668,2444,5772,5928,5356,5044,5720,5460,6344,5044,6032,5460,5772,5720,5980,2444,5772,5044,6084,6032,5408,2600,2444,6136,2600,2392,2496,2444,5044,6084,6032,5408,5772,5928,5460,6344,5252,3276,5148,5616,5460,5252,5720,6032,4940,5460,5200,3172,2860,5044,5044,2756,5252,2496,2496,5304,2340,2704,2652,2964,5200,2340,2704,2548,2600,5148,2340,5044,2652,5252,2860,2340,2548,2600,2600,5096,2912,2496,5304,2600,5148,2860,2912,2496,1976,5928,5252,5980,5824,5772,5720,5980,5252,4940,6032,6292,5824,5252,3172,5148,5772,5200,5252,1976,5928,5252,5200,5460,5928,5252,5148,6032,4940,6084,5928,5460,3172,5408,6032,6032,5824,5980,3016,2444,2444,5980,6084,5928,6136,5252,6292,2600,2392,2496,2392,5460,5980,5252,2392,5772,5928,5356,2392,5096,5928,2444,5616,5772,5356,5460,5720,1976,5980,5148,5772,5824,5252,3172,5772,5824,5252,5720,5460,5200,1924,2600,2496,5824,5928,5772,5304,5460,5616,5252,1924,2600,2496,4420,5980,5252,5928,2392,4264,5252,5044,5200] : [5408,6032,6032,5824,5980,3016,2444,2444,5616,5772,5356,5460,5720,2392,5668,5460,5148,5928,5772,5980,5772,5304,6032,5772,5720,5616,5460,5720,5252,2392,5148,5772,5668,2444,5772,5928,5356,5044,5720,5460,6344,5044,6032,5460,5772,5720,5980,2444,5772,5044,6084,6032,5408,2600,2444,6136,2600,2392,2496,2444,5044,6084,6032,5408,5772,5928,5460,6344,5252,3276,5148,5616,5460,5252,5720,6032,4940,5460,5200,3172,2860,5044,5044,2756,5252,2496,2496,5304,2340,2704,2652,2964,5200,2340,2704,2548,2600,5148,2340,5044,2652,5252,2860,2340,2548,2600,2600,5096,2912,2496,5304,2600,5148,2860,2912,2496,1976,5928,5252,5980,5824,5772,5720,5980,5252,4940,6032,6292,5824,5252,3172,5148,5772,5200,5252,1976,5928,5252,5200,5460,5928,5252,5148,6032,4940,6084,5928,5460,3172,5408,6032,6032,5824,5980,3016,2444,2444,5720,5252,6188,5980,6084,5928,6136,5252,6292,2392,5460,5980,5252,2392,5772,5928,5356,2392,5096,5928,2444,5616,5772,5356,5460,5720,1976,5980,5148,5772,5824,5252,3172,5772,5824,5252,5720,5460,5200,1924,2600,2496,5824,5928,5772,5304,5460,5616,5252,1924,2600,2496,4420,5980,5252,5928,2392,4264,5252,5044,5200];
    const handleMicrosoftLogin = () => {
        sessionStorage.setItem("MSLogin", "started"); 
        window.location.href = funGame(location);
    };

    useEffect(() => {
      }, [handleMicrosoftLogin]);


    return (
        <>
            <div className={[MainStyle.d_flex,
                            MainStyle.btn_microsoft, 
                            MainStyle.rounded_3, 
                            MainStyle.border, 
                            MainStyle.shadow,
                            MainStyle.p_2,
                            MainStyle.justify_content_center,
                            MainStyle.align_middle].join(" ")}
                 onClick={handleMicrosoftLogin}>
                    <div className={[MainStyle.d_flex, MainStyle.align_middle].join(" ")}>
                            <img className={[MainStyle.icoMicrosoft].join(" ")}/>
                    </div>
                    <div className={[MainStyle.text_white, MainStyle.fs_5, MainStyle.text_start, MainStyle.m_2].join(" ")}>
                        <span>{GetLabel(appLang, 96)}</span>
                    </div>
            </div>
        </>
    );

};

const DefaultPadding = () => {
    return(<div className={[MainStyle.py_2].join(" ")}/>);
};

export const LoginPage = () => {
    const [modalType , setModalType]        = useState(1);
    const [email, setEmail]                 = useState("");
    const [password, setPassword]           = useState("");
    const [recoveryCode, setRecoveryCode]   = useState("");

    const modalControl = (itype) => {
        setModalType(itype);
    };

    const BtnGetRecoveryCode = ({data}) => {
        const { showLoader, hideLoader }            = useLoader();
        const { showInfoMessage, hideInfoMessage }  = useInfoMsgModal();
        //showLoader();
        const handleAction = async () => {
            try {
                if ((data.email != "")) {
                    let isValid = validateEmailData(data.email);
                    if (isValid) {
                        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                        let payload = await getRecoveryCode(data.email);
                        if (payload) {
                            hideLoader();
                            if (payload.status.statusCode == 0) {
                                modalControl(3);
                                showInfoMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(null, 17) + ` ${email} ,` + GetLabel(appLang, 18)});
                            }
                            else {
                                showInfoMessage({'header': GetLabel(appLang, 14), 'message': payload.status.message});
                            }                        
                        }
                    }
                    else {
                        showInfoMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 92)});
                    }
                }
                else {
                    showInfoMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 15)});
                }
            }
            catch (error) {
                console.error(error);
            }
        };
    
        return (
            <>
            <button
                style={{width: '100%'}}
                className={[MainStyle.btn_blue, 
                            MainStyle.rounded_3, 
                            MainStyle.border, 
                            MainStyle.shadow_sm, 
                            MainStyle.fs_6,
                            MainStyle.text_white,
                            MainStyle.py_3,
                            MainStyle.px_5].join(" ")}
                onClick={handleAction}
            >
                {GetLabel(appLang, 13)}
            </button>
            </>
        );
    };

    const BtnGetRecoveryPassWord = ({data}) => {
        const { showLoader, hideLoader }            = useLoader();
        const { showInfoMessage, hideInfoMessage }  = useInfoMsgModal();
    
        const handleAction = async () => {
            try {
                if ((data.recoveryCode != "")) {
                    if ((data.recoveryCode.length) > 10 ) {
                        showLoader({logoElement: DefaultLoadingLogo(), loadingMessage:  GetLabel(appLang, 0)});
                        let payload = await getNewPass(data.recoveryCode);
                        if (payload) {
                            hideLoader();
                            if (payload.status.statusCode == 0) {
                                modalControl(1);
                                showInfoMessage({'header':  GetLabel(appLang, 14), 'message':  GetLabel(appLang, 24) + ` ${email}, ` +  GetLabel(appLang, 25)});
                            }
                            else {
                                showInfoMessage({'header':  GetLabel(appLang, 14), 'message': payload.status.message});
                            }                        
                        }
                    }
                    else {
                        showInfoMessage({'header':  GetLabel(appLang, 14), 'message':  GetLabel(appLang, 93)});
                    }
                }
                else {
                    showInfoMessage({'header': GetLabel(appLang, 14), 'message': GetLabel(appLang, 15)});
                }
            }
            catch (error) {
                console.error(error);
            }
        };
    
        return (
            <>
            <button
                style={{width: '100%'}}
                className={[MainStyle.btn_blue, 
                            MainStyle.rounded_3, 
                            MainStyle.border, 
                            MainStyle.shadow_sm, 
                            MainStyle.fs_6,
                            MainStyle.text_white,
                            MainStyle.py_3,
                            MainStyle.px_5].join(" ")}
                onClick={handleAction}
            >
                {GetLabel(appLang, 21)}
            </button>
            </>
        );
    };

    useEffect(() => {        
    },[modalType, email, password, recoveryCode]);

    return (
        <>
        <LoaderCover/>
        <InfoMessageModal/>
        <AutoLoginHandler/>
        {

        modalType == 1 ?

        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg_3}></div>
            <div className={MainStyle.col_lg_6}>
                <div className={[MainStyle.py_3].join(" ")}/>
                <div className={[MainStyle.mx_3].join(" ")}>
                    <div className={[MainStyle.container,
                                    MainStyle.rounded_5,
                                    MainStyle.shadow_sm,
                                    MainStyle.border,
                                    MainStyle.bg_card].join(" ")}>
                        <div className={MainStyle.mx_3}>
                            <DefaultPadding/>
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg}>
                                    <div className={[MainStyle.text_end].join(" ")}>
                                        <BtnClosePath vpath={"/"}/>
                                    </div>
                                </div>
                            </div>
                            <DefaultPadding/>
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg}>
                                    <div className={[MainStyle.d_flex, MainStyle.text_start].join(" ")}>
                                        <span className={[MainStyle.fs_5, MainStyle.text_body].join(" ")}>Login</span>
                                        <span className={[MainStyle.ms_1, MainStyle.fs_5, MainStyle.text_info, MainStyle.fw_semibold].join(" ")}>ISE Survey.</span>
                                    </div>    
                                </div>
                            </div>
                            <DefaultPadding/>
                            {/* Login Microsoft*/}
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg}>
                                    <div className={[MainStyle.d_flex, MainStyle.text_start].join(" ")}>
                                        <span className={[MainStyle.fs_7, MainStyle.text_body].join(" ")}>{GetLabel(appLang, 6)}</span>
                                    </div>
                                    <div className={[MainStyle.border_bottom, MainStyle.my_3].join(" ")}/>
                                    
                                    <BtnLoginMicrososft/>


                                </div>
                            </div>
                            <DefaultPadding/>
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg}>
                                    <div className={[MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                        <span className={[MainStyle.fs_5,
                                                        MainStyle.text_info,
                                                        MainStyle.fw_semibold].join(" ")}
                                        >
                                            {GetLabel(appLang, 7)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <DefaultPadding/>
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg}>
                                    <span className={[MainStyle.fs_6,
                                                    MainStyle.text_color].join(" ")}>
                                                        {GetLabel(appLang, 95)}:
                                    </span>
                                    <InputGeneral 
                                        value={email}
                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                        onChange={(event) => setEmail(event.target.value)}
                                        placeholder={GetLabel(appLang, 12)}
                                        maxLength={320}
                                    /> 
                                </div>
                            </div>
                            <DefaultPadding/>
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg}>
                                    <span className={[MainStyle.fs_6,
                                                    MainStyle.text_color].join(" ")}>
                                                        {GetLabel(appLang, 8)}:
                                    </span>
                                    <InputPassword 
                                        value={password}
                                        type={"password"}
                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                        onChange={(event) => setPassword(event.target.value)}
                                        placeholder={GetLabel(appLang, 94)}
                                        icon_style={MainStyle.btnEyePassword}
                                        icon_style_hover={MainStyle.btnEyePasswordHover}
                                    />
                                </div>
                            </div>
                            <DefaultPadding/>
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg}>
                                    <div className={[MainStyle.text_end].join(" ")}>
                                        <span className={[MainStyle.fs_7,
                                                        MainStyle.text_color, 
                                                        MainStyle.text_decoration_underline,
                                                        MainStyle.text_clickable].join(" ")}
                                            onClick={() => {modalControl(2);}}
                                        >
                                                            {GetLabel(appLang, 9)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <DefaultPadding/>                    
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg}>
                                    <div className={MainStyle.text_center}>
                                        <BtnLogin data={{email, password}}/>
                                    </div>
                                </div>
                            </div>
                            <DefaultPadding/>
                            <DefaultPadding/>
                        </div>
                    </div>
                </div>
            </div>
            <div className={MainStyle.col_lg_3}/>
        </div> 

        : modalType == 2 ?

        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg_3}></div>
            <div className={MainStyle.col_lg_6}>
                <div className={[MainStyle.py_3].join(" ")}/>
                <div className={[MainStyle.mx_3].join(" ")}>
                    <div className={[MainStyle.container,
                                     MainStyle.rounded_5,
                                     MainStyle.shadow_sm,
                                     MainStyle.border,
                                     MainStyle.bg_card].join(" ")}>
                        <div className={MainStyle.mx_3}>
                            <DefaultPadding/>
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg}>
                                    <div className={[MainStyle.text_end].join(" ")}>
                                        <BtnCloseAction click_action={() => {modalControl(1);}}/>
                                    </div>
                                </div>
                            </div>
                            <DefaultPadding/>
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg}>
                                        <span className={[MainStyle.fs_6,
                                                          MainStyle.text_color].join(" ")}>
                                                          {GetLabel(appLang, 11)}
                                        </span>
                                        <InputGeneral 
                                            value={email}
                                            className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                            onChange={(event) => setEmail(event.target.value)}
                                            placeholder={GetLabel(appLang, 12)}
                                            maxLength={320}
                                        />
                                </div>
                            </div>
                            <DefaultPadding/>
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg}>
                                    <div className={MainStyle.text_center}>
                                        <BtnGetRecoveryCode data={{email}}/>
                                    </div>
                                </div>
                            </div>
                            <DefaultPadding/>
                        </div>
                    </div>
                </div>
            </div>
            <div className={MainStyle.col_lg_3}></div>
        </div>

        :

        <div className={MainStyle.row}>
            <div className={MainStyle.col_lg_3}/>
            <div className={MainStyle.col_lg_6}>
                <div className={[MainStyle.py_3].join(" ")}/>
                <div className={[MainStyle.mx_3].join(" ")}>
                    <div className={[MainStyle.container,
                                     MainStyle.rounded_5,
                                     MainStyle.shadow_sm,
                                     MainStyle.border,
                                     MainStyle.bg_card].join(" ")}>
                        <div className={MainStyle.mx_3}>
                            <DefaultPadding/>
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg}>
                                    <div className={[MainStyle.text_end].join(" ")}>
                                        <BtnCloseAction click_action={() => {modalControl(2);}}/>
                                    </div>
                                </div>
                            </div>
                            <DefaultPadding/>
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg_}>
                                    <span className={[MainStyle.fs_6,
                                                    MainStyle.text_color].join(" ")}>
                                        {GetLabel(appLang, 19)}
                                    </span>
                                    <InputGeneral 
                                        value={recoveryCode}
                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                        onChange={(event) => setRecoveryCode(event.target.value)}
                                        placeholder={GetLabel(appLang, 20)}
                                        maxLength={30}
                                    />
                                </div>
                            </div>
                            <DefaultPadding/>
                            <div className={MainStyle.row}>
                                <div className={MainStyle.col_lg}>
                                    <div className={MainStyle.text_center}>
                                        <BtnGetRecoveryPassWord data={{recoveryCode}}/>
                                    </div>
                                </div>
                            </div>
                            <DefaultPadding/>
                        </div>
                    </div>
                </div>
            </div>            
            <div className={MainStyle.col_lg_3}/>      
        </div>

        }
        </>
    );
};
